/*
 * This file is part of glowingblue/gamilytics.
 *
 * Copyright (c) 2024 Glowing Blue AG.
 * Authors: Davide Iadeluca.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import Extend from 'flarum/common/extenders';
import { default as extend } from '../common/extend';
import User from 'flarum/common/models/User';
import Rank from '../common/models/Rank';
import GlobalStats from '../common/models/GlobalStats';
import LeaderboardPage from './leaderboards/components/LeaderboardPage';
import LevelHistory from './levels/models/LevelHistory';
import LevelChangedNotification from './levels/components/LevelChangedNotification';
import AchievementUnlockedNotification from './achievements/components/AchievementUnlockedNotification';
import AchievementsPage from './achievements/components/AchievementsPage';
import AchievementPage from './achievements/components/AchievementPage';
import AchievementUsersPage from './achievements/components/AchievementUsersPage';
import AchievementsProfilePage from './achievements/components/AchievementsProfilePage';
import GamificationResolver from './resolvers/GamificationResolver';
export default [...extend, new Extend.Store() //
.add('global_stats', GlobalStats).add('gamilytics_leaderboard_ranks', Rank).add('level_history', LevelHistory), new Extend.Model(User) //
.attribute('activitySummary').attribute('exp').attribute('level').attribute('achievementsCount').hasMany('userAchievements'), new Extend.Notification() //
.add('levelChanged', LevelChangedNotification).add('achievementUnlocked', AchievementUnlockedNotification), new Extend.Routes() //
.add('leaderboard', '/leaderboard', LeaderboardPage, GamificationResolver).add('activityLeaderboard', '/leaderboard/:activityType', LeaderboardPage, GamificationResolver).add('achievements', '/achievements/c/:category', AchievementsPage, GamificationResolver).add('achievement', '/achievements/:id', AchievementPage, GamificationResolver).add('achievement-users', '/achievement-users/:levelId', AchievementUsersPage, GamificationResolver).add('user.achievements', '/u/:username/achievements', AchievementsProfilePage, GamificationResolver)];